import template from './notification-detail.html';
import controller from './notification-detail.controller';

let notificationDetailComponent = {
  bindings: {},
  template,
  controller
};

export default notificationDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/notification/notification-detail.component.js